import { Button, IconButton, Stack, styled } from '@mui/material';
import { SimpleCard } from '@schooly/style';

export const AttendanceStatsLayout = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: theme.spacing(1.5),
  width: '100%',
  '& .MuiCard-root': { flex: 1 },
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

// https://www.figma.com/file/rN8wIkDdHQ5TasMRwh9al7/Schooly-%23-1-approved?node-id=11824%3A164205&t=agcR3funXMxsUKFD-0
export const PercentButton = styled(Button)(({ theme }) => ({
  minWidth: 0,
  padding: theme.spacing(0.5),
  borderRadius: theme.shape.borderRadiusSm,
  '&:active': { padding: theme.spacing(0.5) },
}));

export const PercentIconButton = styled(IconButton)(({ theme }) => ({
  '&:hover': { color: theme.palette.primary.main },
}));

export const AttendanceStatsJustificationCard = styled(SimpleCard, {
  shouldForwardProp: (prop) => prop !== 'disabled',
})<{ disabled?: boolean }>(({ theme, disabled }) => ({
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.common.light2}`,
  '.MuiCardActionArea-focusHighlight': {
    background: 'transparent',
  },
  ':hover': {
    backgroundColor: theme.palette.common.lightBg,
    color: theme.palette.primary.main,
    '.MuiIconButton-root': {
      color: theme.palette.primary.main,
    },
  },
  ...(disabled && {
    '.MuiButtonBase-root': { cursor: 'default', '& .MuiIconButton-root': { visibility: 'hidden' } },
  }),
}));
